import { createAction } from 'actions/utils';
import {
    CLEAR_CRUD_CODE,
    DELETE_CODE_SUCCESS,
    GET_CRUD_CODE_REQUEST,
    GET_CRUD_CODE_SUCCESS,
    GET_CRUD_CODE_ERROR,
    GET_CUSTOM_CODE_REQUEST,
    GET_CUSTOM_CODE_SUCCESS,
    GET_CUSTOM_CODE_ERROR,
    GET_CUSTOM_CODES_REQUEST,
    GET_CUSTOM_CODES_SUCCESS,
    GET_CUSTOM_CODES_ERROR,
} from 'constants/ActionTypes';
import { Core } from 'managers';

export function getCodes() {
    return (dispatch) => {
        dispatch(createAction(GET_CUSTOM_CODES_REQUEST, {}));
        return Core.customCodesManager.getCodes().then(
            (res) => {
                dispatch(createAction(GET_CUSTOM_CODES_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_CUSTOM_CODES_ERROR, error));
                throw error;
            },
        );
    };
}

export function getCode({ name }) {
    return (dispatch) => {
        dispatch(createAction(GET_CUSTOM_CODE_REQUEST, {}));
        return Core.customCodesManager.getCode(name).then(
            (res) => {
                dispatch(createAction(GET_CUSTOM_CODE_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_CUSTOM_CODE_ERROR, error));
                throw error;
            },
        );
    };
}

export function getCrudCode({ name }) {
    return (dispatch) => {
        dispatch(createAction(GET_CRUD_CODE_REQUEST, {}));
        return Core.customCodesManager.getCrudCode(name).then(
            (res) => {
                dispatch(createAction(GET_CRUD_CODE_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_CRUD_CODE_ERROR, error));
                throw error;
            },
        );
    };
}

export function clearCurrentCode() {
    return (dispatch) => {
        dispatch(createAction(CLEAR_CRUD_CODE, {}));
    };
}

export function deleteCode(name) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Core.customCodesManager.deleteCode(name).then(
                (res) => {
                    if (res && res.code === 1) {
                        dispatch(createAction(DELETE_CODE_SUCCESS, name));
                        resolve(res);
                    } else {
                        reject();
                    }
                },
                (error) => {
                    reject(error);
                },
            );
        });
}
